import RightRailAdRaw from "../ads/RightRailAdRaw.js";

export default function RightRailLayout({ children }) {
  const showRail = process.env.REACT_APP_SHOW_RIGHT_RAIL !== "0"; // 環境変数で切替可
  return (
    <div className="app-two-col">
      <main className="main-col">{children}</main>
      {showRail && (
        <aside className="right-rail">
          <RightRailAdRaw />
        </aside>
      )}
    </div>
  );
}
